<template>
  <span class="status-pill" :class="`status-pill--${state}`">
    <span class="status-pill__dot"></span>
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { PillState } from "../subscriptionLogic";

const props = defineProps<{ state: PillState }>();

const label = computed(() => {
  switch (props.state) {
    case "cancelled":
      return "Cancelled";
    case "paused":
      return "Paused";
    case "fixed_term":
      return "Fixed term";
    case "payment_failed":
      return "Payment failed";
    default:
      return "Active";
  }
});
</script>

<style scoped lang="scss">
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #000;
  white-space: nowrap;

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.35);
  }

  &--active {
    background-color: #4caf50;
  }

  &--cancelled {
    background-color: #e53935;
  }

  &--paused {
    background-color: #fb8c00;
  }

  // Deliberately not the cancelled red. A fixed-term grant is access the
  // customer paid for and still has; it earns a calm colour, not a warning one.
  &--fixed_term {
    background-color: #29b6f6;
  }

  // Urgent like cancelled, but distinguishable from it — this one is fixable.
  &--payment_failed {
    background-color: #c62828;
  }
}
</style>
